export enum ChooseSailingSearchParams {
  packageCode = 'packageCode',
  voyageId = 'voyageId',
}
